import { Injectable } from '@angular/core';
import { PerfilEstrutura } from '../models/perfil-estrutura';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class PerfilEstruturaService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(perfilEstrutura: PerfilEstrutura) {
    return this.http.post(globals.apiUrl + '/api/PerfilEstrutura/Salvar', perfilEstrutura);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/PerfilEstrutura/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPerfilEstrutura(id: number) {
    return this.http.get<PerfilEstrutura>(globals.apiUrl + '/api/PerfilEstrutura/Buscar', {
      params: new HttpParams()
        .set('id', id.toString())
    });
  }

  consultarLista() {
    return this.http.get<PerfilEstrutura[]>(globals.apiUrl + '/api/PerfilEstrutura/Lista');
  }

  consultarPerfilEstruturaComPaginacao(idMaxPainel, tamPerfil, larguraModulo, orientacao, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idMaxPainel', idMaxPainel)
      .set('tamPerfil', tamPerfil)
      .set('larguraModulo', larguraModulo)
      .set('orientacao', orientacao)
    ;

    return this.http.get<any>(globals.apiUrl + '/api/PerfilEstrutura/ListaPag',
      {
        params: parametros
      });
  }

  exportar(idMaxPainel, tamPerfil, larguraModulo, orientacao) {
    let parametros = new HttpParams()
      .set('idMaxPainel', idMaxPainel || '')
      .set('tamPerfil', tamPerfil || '')
      .set('larguraModulo', larguraModulo || '')
      .set('orientacao', orientacao !== undefined || orientacao !== null ? orientacao : '');

    return this.http.get(globals.apiUrl + '/api/PerfilEstrutura/BaixarModelo', { params: parametros, responseType: 'blob' });
  }

  importar(dados) {
    return this.http.post(globals.apiUrl + '/api/PerfilEstrutura/Importar', dados);
  }
}
